import React from 'react';
import { motion } from 'framer-motion';
export function ComingSoonPage() {
  return <div className="min-h-screen bg-gradient-to-b from-gray-950 via-gray-900 to-black flex flex-col items-center justify-center px-6 relative overflow-hidden" data-id="element-40">
      {/* Subtle background glow */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-41">
        <div className="absolute top-1/3 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-purple-600/10 rounded-full blur-[150px]" data-id="element-42" />
      </div>

      {/* Content */}
      <motion.div className="relative z-10 text-center max-w-lg mx-auto" initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6,
      ease: 'easeOut'
    }} data-id="element-43">
        {/* Logo */}
        <motion.div className="mb-12" initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} data-id="element-44">
          <img src="https://cdn.magicpatterns.com/uploads/qxKLGQczqeyzmB6PfiAg11/Asset_11x.png" alt="Brixen Credit" className="h-10 md:h-12 w-auto mx-auto" data-id="element-45" />
        </motion.div>

        {/* Main Headline */}
        <motion.h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 tracking-tight" initial={{
        opacity: 0,
        y: 15
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} data-id="element-46">
          BIENVENIDO A BRIXEN CREDIT
        </motion.h1>

        {/* Supporting text */}
        <motion.p className="text-base md:text-lg text-white/50 mb-12 max-w-md mx-auto font-light leading-relaxed" initial={{
        opacity: 0,
        y: 15
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} data-id="element-47">
          Solicita información y recibe asistencia de nuestro equipo.
        </motion.p>

        {/* CTA Button */}
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.5
      }} data-id="element-48">
          <a href="https://apply.brixencredit.com/" className="inline-block" data-id="element-49">
            <motion.button className="relative px-10 py-4 bg-gradient-to-r from-purple-600 to-purple-500 text-white font-semibold text-lg rounded-full shadow-lg shadow-purple-500/25 overflow-hidden" type="button" whileHover={{
            scale: 1.05,
            boxShadow: '0 25px 50px -12px rgba(147, 51, 234, 0.5)'
          }} whileTap={{
            scale: 0.97
          }} animate={{
            boxShadow: ['0 10px 30px -10px rgba(147, 51, 234, 0.3)', '0 20px 40px -10px rgba(147, 51, 234, 0.5)', '0 10px 30px -10px rgba(147, 51, 234, 0.3)']
          }} transition={{
            boxShadow: {
              duration: 2,
              repeat: Infinity,
              ease: 'easeInOut'
            }
          }} data-id="element-50">
              {/* Shimmer effect */}
              <motion.div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -skew-x-12" animate={{
              x: ['-200%', '200%']
            }} transition={{
              duration: 2.5,
              repeat: Infinity,
              ease: 'easeInOut',
              repeatDelay: 1
            }} data-id="element-51" />
              <span className="relative z-10" data-id="element-52">SOLICITAR INFORMACIÓN</span>
            </motion.button>
          </a>

          <motion.p className="text-xs md:text-sm text-white/35 mt-6 max-w-md mx-auto font-light leading-relaxed px-4" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.5,
          delay: 0.6
        }} data-id="element-53">
            Al enviar tu información, aceptas ser contactado por Brixen Credit
            LLC sobre tu solicitud. Puedes responder STOP para dejar de recibir
            mensajes.
          </motion.p>
        </motion.div>
      </motion.div>

      {/* Footer links */}
      <motion.div className="absolute bottom-8 left-0 right-0 text-center" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 0.5,
      delay: 0.7
    }} data-id="element-54">
        <div className="flex flex-wrap justify-center gap-6 text-sm text-white/30" data-id="element-55">
          <a href="/privacy" className="hover:text-white/60 transition-colors" data-id="element-56">
            Privacidad
          </a>
          <a href="/terms" className="hover:text-white/60 transition-colors" data-id="element-57">
            Términos
          </a>
          <a href="/refund" className="hover:text-white/60 transition-colors" data-id="element-58">
            Reembolsos
          </a>
        </div>
      </motion.div>
    </div>;
}